import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

//----- store
import { fetchCardData } from "../../store/cardRunningActions-actions";

import { makeStyles } from "@material-ui/core/styles";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

import LoadingSpinner from "../UI/LoadingSpinner/LoadingSpinner";

import Icon from "@material-ui/core/Icon";
import IconButton from "@material-ui/core/IconButton";

import Styles from "./CardRunningActions.module.css";

const useStyles = makeStyles((theme) => ({
	container: {
		maxHeight: 295,
	},
}));

const CardRunningActions = () => {
	const dispatch = useDispatch();
	const classes = useStyles();
	const history = useHistory();
	
	const isLoading = useSelector((state) => state.uiData.isLoading[4]);

	const cardRunningActionsData = useSelector(
		(state) => state.cardRunningActionsData
	);
	const autenticationData = useSelector(
		(state) => state.uiData.autentication
	);

	const apiConfigData = useSelector((state) => state.apiConfigData);

	const url_data =
		apiConfigData.endpoint.domain +
		apiConfigData.endpoint.dashboard.runningActions;

	const iconButtonClickHandler = (item) => {
		// console.log(item.id);
		history.push("/formacao/courses/actions/details/" + item.id);
	};

	useEffect(() => {
		dispatch(fetchCardData(url_data, autenticationData));
	}, [dispatch]);

	useEffect(() => {
		console.log("cardRunningActionsData", cardRunningActionsData);

	}, [cardRunningActionsData]);

	return (
		<div className={Styles["CardRunningActions"]}>
			<TableContainer className={classes.container}>
				<Table stickyHeader aria-label="Courses table">
					<TableHead>
						<TableRow className={Styles["MuiTableRow-head"]}>
							<TableCell
								className={Styles["MuiTableCell-head"]}
								align="left"
							>
								<div className={Styles["title"]}>
									Nome do Módulo
								</div>
							</TableCell>
							<TableCell
								className={Styles["MuiTableCell-head"]}
								align="left"
							>
								<div className={Styles["title"]}>
									Data Início
								</div>
							</TableCell>
							<TableCell
								className={Styles["MuiTableCell-head"]}
								align="left"
							>
								<div className={Styles["title"]}>Data Fim</div>
							</TableCell>
							<TableCell
								className={Styles["MuiTableCell-head"]}
								align="left"
							></TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{!isLoading && cardRunningActionsData.cardData.map((row) => (
							<TableRow
								key={row.id}
								className={Styles["MuiTableBody-root"]}
							>
								<TableCell
									className={Styles["MuiTableCell-root"]}
									align="left"
									component="th"
									scope="row"
									width="220px"
								>
									<div className={Styles["subtitle"]}>
										{row.name}
									</div>
								</TableCell>
								<TableCell
									className={Styles["MuiTableCell-root"]}
									align="left"
								>
									<div className={Styles["subtitle"]}>
										{row.startDateStr}
									</div>
								</TableCell>
								<TableCell
									className={Styles["MuiTableCell-root"]}
									align="left"
								>
									<div className={Styles["subtitle"]}>
										{row.endDateStr}
									</div>
								</TableCell>
								<TableCell
									className={Styles["MuiTableCell-root"]}
									align="left"
								>
									<div className={Styles["subtitle"]}>
										<IconButton
											aria-label="forward"
											onClick={iconButtonClickHandler.bind(
												null,
												row
											)}
										>
											<Icon>arrow_forward_ios</Icon>
										</IconButton>
									</div>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
				{isLoading && (
					<div style={{ textAlign: "center" }}>
						<LoadingSpinner />
					</div>
				)}
				{cardRunningActionsData.cardData.length == 0 && (
					<div className={Styles["no-record-found"]}>
						Não existe nenhum módulo a decorrer
					</div>
				)}
			</TableContainer>
		</div>
	);
};

export default CardRunningActions;
